var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );
dependencies["product-meta/afterpay/afterpay-logo-small.j2"] = require( "product-meta/afterpay/afterpay-logo-small.j2" );
dependencies["product-meta/afterpay/afterpay-info-icon.j2"] = require( "product-meta/afterpay/afterpay-info-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/afterpay/afterpay-message.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "product/templates/product-meta/afterpay/afterpay-message.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayPriceValue")) {
var t_4 = t_1.displayPriceValue;
} else {
cb(new Error("cannot import 'displayPriceValue'")); return;
}
context.setVariable("displayPriceValue", t_4);
var t_5;
t_5 = (lineno = 2, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.afterpay.statuses.QUALIFY"]));
frame.set("AP_QUALIFY", t_5, true);
if(frame.topLevel) {
context.setVariable("AP_QUALIFY", t_5);
}
if(frame.topLevel) {
context.addExport("AP_QUALIFY", t_5);
}
var t_6;
t_6 = (lineno = 3, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.afterpay.statuses.NOTIFY"]));
frame.set("AP_NOTIFY", t_6, true);
if(frame.topLevel) {
context.setVariable("AP_NOTIFY", t_6);
}
if(frame.topLevel) {
context.addExport("AP_NOTIFY", t_6);
}
var t_7;
t_7 = (lineno = 4, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.afterpay.statuses.OFF"]));
frame.set("AP_OFF", t_7, true);
if(frame.topLevel) {
context.setVariable("AP_OFF", t_7);
}
if(frame.topLevel) {
context.addExport("AP_OFF", t_7);
}
var t_8;
t_8 = (lineno = 7, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.afterpay.minAmount",0]));
frame.set("afterpayMin", t_8, true);
if(frame.topLevel) {
context.setVariable("afterpayMin", t_8);
}
if(frame.topLevel) {
context.addExport("afterpayMin", t_8);
}
var t_9;
t_9 = (lineno = 8, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.afterpay.maxAmount",0]));
frame.set("afterpayMax", t_9, true);
if(frame.topLevel) {
context.setVariable("afterpayMax", t_9);
}
if(frame.topLevel) {
context.addExport("afterpayMax", t_9);
}
var t_10;
t_10 = runtime.contextOrFrameLookup(context, frame, "afterpayMin") && runtime.contextOrFrameLookup(context, frame, "afterpayMax");
frame.set("minMaxExists", t_10, true);
if(frame.topLevel) {
context.setVariable("minMaxExists", t_10);
}
if(frame.topLevel) {
context.addExport("minMaxExists", t_10);
}
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "minMaxExists") && (lineno = 12, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ab.SS_AFTERPAY",1])) == 1;
frame.set("afterpayEnabled", t_11, true);
if(frame.topLevel) {
context.setVariable("afterpayEnabled", t_11);
}
if(frame.topLevel) {
context.addExport("afterpayEnabled", t_11);
}
if(runtime.contextOrFrameLookup(context, frame, "afterpayEnabled")) {
var t_12;
t_12 = (lineno = 16, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.sku"]));
frame.set("selectedSku", t_12, true);
if(frame.topLevel) {
context.setVariable("selectedSku", t_12);
}
if(frame.topLevel) {
context.addExport("selectedSku", t_12);
}
var t_13;
t_13 = (runtime.contextOrFrameLookup(context, frame, "selectedSku")?(lineno = 17, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.sku.afterpay",{}])):(lineno = 17, colno = 101, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.skuInfo.afterpay",{}])));
frame.set("productOrSkuAfterpay", t_13, true);
if(frame.topLevel) {
context.setVariable("productOrSkuAfterpay", t_13);
}
if(frame.topLevel) {
context.addExport("productOrSkuAfterpay", t_13);
}
var t_14;
t_14 = (lineno = 18, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "productOrSkuAfterpay"),"status",runtime.contextOrFrameLookup(context, frame, "AP_OFF")]));
frame.set("afterpayStatus", t_14, true);
if(frame.topLevel) {
context.setVariable("afterpayStatus", t_14);
}
if(frame.topLevel) {
context.addExport("afterpayStatus", t_14);
}
var t_15;
t_15 = (lineno = 19, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "productOrSkuAfterpay"),"numOfPayments",0]));
frame.set("numOfPayments", t_15, true);
if(frame.topLevel) {
context.setVariable("numOfPayments", t_15);
}
if(frame.topLevel) {
context.addExport("numOfPayments", t_15);
}
var t_16;
t_16 = (lineno = 20, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "productOrSkuAfterpay"),"payment",0]));
frame.set("paymentPrice", t_16, true);
if(frame.topLevel) {
context.setVariable("paymentPrice", t_16);
}
if(frame.topLevel) {
context.addExport("paymentPrice", t_16);
}
var t_17;
t_17 = runtime.contextOrFrameLookup(context, frame, "afterpayStatus") == runtime.contextOrFrameLookup(context, frame, "AP_QUALIFY") && runtime.contextOrFrameLookup(context, frame, "numOfPayments") && runtime.contextOrFrameLookup(context, frame, "paymentPrice");
frame.set("productOrSkuQualifies", t_17, true);
if(frame.topLevel) {
context.setVariable("productOrSkuQualifies", t_17);
}
if(frame.topLevel) {
context.addExport("productOrSkuQualifies", t_17);
}
var t_18;
t_18 = runtime.contextOrFrameLookup(context, frame, "afterpayStatus") == runtime.contextOrFrameLookup(context, frame, "AP_NOTIFY");
frame.set("productOrSkuNotify", t_18, true);
if(frame.topLevel) {
context.setVariable("productOrSkuNotify", t_18);
}
if(frame.topLevel) {
context.addExport("productOrSkuNotify", t_18);
}
if(runtime.contextOrFrameLookup(context, frame, "productOrSkuQualifies") || runtime.contextOrFrameLookup(context, frame, "productOrSkuNotify")) {
output += "<p class=\"c-afterpay\" data-qa-afterpay>\n\n            <span class=\"c-afterpay__message\" data-qa-afterpay-message>";
if(runtime.contextOrFrameLookup(context, frame, "productOrSkuQualifies")) {
var t_19;
t_19 = (lineno = 33, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ab.SS_AFTERPAYMSG",0]));
frame.set("afterpayMsgCookieValue", t_19, true);
if(frame.topLevel) {
context.setVariable("afterpayMsgCookieValue", t_19);
}
if(frame.topLevel) {
context.addExport("afterpayMsgCookieValue", t_19);
}
var t_20;
t_20 = (runtime.contextOrFrameLookup(context, frame, "afterpayMsgCookieValue")?("_" + "" + runtime.contextOrFrameLookup(context, frame, "afterpayMsgCookieValue")):"");
frame.set("afterpayMsgSlugSuffix", t_20, true);
if(frame.topLevel) {
context.setVariable("afterpayMsgSlugSuffix", t_20);
}
if(frame.topLevel) {
context.addExport("afterpayMsgSlugSuffix", t_20);
}
var t_21;
t_21 = [runtime.contextOrFrameLookup(context, frame, "numOfPayments"),(lineno = 36, colno = 68, runtime.callWrap(t_4, "displayPriceValue", context, [runtime.contextOrFrameLookup(context, frame, "paymentPrice"),runtime.contextOrFrameLookup(context, frame, "core")]))];
frame.set("params", t_21, true);
if(frame.topLevel) {
context.setVariable("params", t_21);
}
if(frame.topLevel) {
context.addExport("params", t_21);
}
output += runtime.suppressValue((lineno = 37, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_afterpay-installments-message" + "" + runtime.contextOrFrameLookup(context, frame, "afterpayMsgSlugSuffix"),runtime.makeKeywordArgs({"params": runtime.contextOrFrameLookup(context, frame, "params")})])), env.opts.autoescape);
;
}
else {
var t_22;
t_22 = [(lineno = 41, colno = 53, runtime.callWrap(t_4, "displayPriceValue", context, [runtime.contextOrFrameLookup(context, frame, "afterpayMin"),runtime.contextOrFrameLookup(context, frame, "core")])),(lineno = 41, colno = 91, runtime.callWrap(t_4, "displayPriceValue", context, [runtime.contextOrFrameLookup(context, frame, "afterpayMax"),runtime.contextOrFrameLookup(context, frame, "core")]))];
frame.set("params", t_22, true);
if(frame.topLevel) {
context.setVariable("params", t_22);
}
if(frame.topLevel) {
context.addExport("params", t_22);
}
output += runtime.suppressValue((lineno = 42, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_afterpay-available-message",runtime.makeKeywordArgs({"params": runtime.contextOrFrameLookup(context, frame, "params")})])), env.opts.autoescape);
;
}
output += "\n            </span><a class=\"js-afterpay-info c-afterpay__info-link\" href=\"#afterpay-info\" ";
output += runtime.suppressValue((lineno = 47, colno = 94, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp","Afterpay","Modal View"])), env.opts.autoescape);
output += ">";
env.getTemplate("product-meta/afterpay/afterpay-logo-small.j2", false, "product/templates/product-meta/afterpay/afterpay-message.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n\n                ";
env.getTemplate("product-meta/afterpay/afterpay-info-icon.j2", false, "product/templates/product-meta/afterpay/afterpay-message.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "</a>\n\n        </p>";
})})})});
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/afterpay/afterpay-message.j2"] , dependencies)